import StatPill from "./StatPill";
import Comet from "./Comet";
import { useScrollReveal } from "@/hooks/useScrollReveal";

import peopleIcon from "@/assets/icons/people-icon.svg";
import bridgesIcon from "@/assets/icons/bridges-icon.svg";
import parksIcon from "@/assets/icons/parks-icon.svg";
import airplaneIcon from "@/assets/icons/airplane-icon.svg";
import seaportsIcon from "@/assets/icons/seaports-icon.svg";
import rocketIcon from "@/assets/icons/rocket-icon.svg";

const stats = [
  { icon: peopleIcon, value: 3.5, suffix: "M", label: "Population" },
  { icon: bridgesIcon, value: 13, suffix: "", label: "International Bridges" },
  { icon: parksIcon, value: 75, suffix: "", label: "Industrial Parks" },
  { icon: airplaneIcon, value: 7, suffix: "", label: "Airports" },
  { icon: seaportsIcon, value: 3, suffix: "", label: "Seaports" },
  { icon: rocketIcon, value: 1, suffix: "", label: "Starbase" },
];

const GatewayStatsSection = () => {
  const heading = useScrollReveal();
  const pills = useScrollReveal();

  return (
    <section className="bg-background pt-6 pb-10 px-4">
      <div className="container mx-auto">
        <div
          ref={heading.ref}
          className={`flex items-center justify-center gap-3 md:gap-8 mb-6 transition-all duration-700 ease-out ${
            heading.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <Comet reverse scale={0.7} mobileScale={0.40} duration={0.9} delay={0.2} />
          <h2 className="text-lg md:text-2xl min-w-[120px] font-bold text-center font-avant-garde">
            Gateway to the Future
          </h2>
          <Comet scale={0.7} mobileScale={0.40} duration={0.9} delay={0.2} />
        </div>

        <div
          ref={pills.ref}
          className={`flex flex-wrap justify-center gap-6 mt-12 max-w-6xl mx-auto transition-all duration-700 ease-out delay-200 ${
            pills.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {stats.map((stat, index) => (
            <StatPill key={index} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default GatewayStatsSection;
